<script>
import conTrainings from 'gkConUI/con-trainings'
import utils from '@/utils'

export default {
  data () {
    return {
    }
  },
  components: {
    conTrainings
  },
  computed: {
    track () {
      return this.$store.state.topics[this.id] || { lectureIds: [] }
    }
  },
  updated () {
    if (this.track.speaker) {
      utils.weixinshare({
        imgUrl: this.track.speaker.avatar,
        title: this.track.topic + this.$store.state.config.wechat_share.default_title
      })
    }
  },
  mounted () {
    if (this.track.speaker) {
      utils.weixinshare({
        imgUrl: this.track.speaker.avatar,
        title: this.track.topic + this.$store.state.config.wechat_share.default_title
      })
    }
  },
  render () {
    return (<con-trainings/>)
  }
}
</script>
